import * as yup from 'yup';

export const signInShopperFormValidationSchema = yup.object().shape({
  email: yup.string().email().required('Por favor ingresa un email válido.'),
  password: yup
    .string()
    .required('Debes ingresar una contraseña para iniciar sesión.'),
});
